import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=1bfbb104&scoped=true&"
import script from "./screenshot.vue?vue&type=script&lang=js&"
export * from "./screenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfbb104",
  null
  
)

export default component.exports